export default {
  OPEN_MODAL_CONTAJE_MAQUINAS: 'OPEN_MODAL_CONTAJE_MAQUINAS',
  OPEN_MODAL_CONTAJE_MAQUINAS_SUCCESS: 'OPEN_MODAL_CONTAJE_MAQUINAS_SUCCESS',
  CLOSE_MODAL_CONTAJE_MAQUINAS: 'CLOSE_MODAL_CONTAJE_MAQUINAS',
  CLOSE_MODAL_CONTAJE_MAQUINAS_SUCCESS: 'CLOSE_MODAL_CONTAJE_MAQUINAS_SUCCESS'
}